import React, { createContext, lazy, Suspense, useContext, useState } from 'react';
import type { BillingAlertBanner } from './banner';
import type { BillingAlert, BillingAlertActionKind } from './types';

export type BillingAlertContextValue = readonly [
  alert: BillingAlert | null,
  banner: BillingAlertBanner | null,
  openAlert: (source?: 'banner' | 'billing' | 'manual') => void,
  executeAction: (action: BillingAlertActionKind) => void,
  pendingAction: BillingAlertActionKind | null
];

const noop = () => undefined;
const DEFAULT_VALUE: BillingAlertContextValue = [null, null, noop, noop, null];

const BillingAlertContext = createContext<BillingAlertContextValue>(DEFAULT_VALUE);
const BillingAlertController = lazy(() => import('./BillingAlertController'));

export const BillingAlertProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [value, setValue] = useState(DEFAULT_VALUE);

  return (
    <BillingAlertContext value={value}>
      {children}
      <Suspense fallback={null}>
        <BillingAlertController onValueChange={setValue} />
      </Suspense>
    </BillingAlertContext>
  );
};

export const useBillingAlert = (): BillingAlertContextValue => useContext(BillingAlertContext);
